import React from 'react';
import { motion } from 'framer-motion';
interface PunjabiPlacardProps {
  word: string;
  translation: string;
}
export const PunjabiPlacard: React.FC<PunjabiPlacardProps> = ({
  word,
  translation
}) => {
  return <motion.div className="absolute bottom-8 left-8 z-30 flex flex-col items-start" initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 1,
    delay: 0.5
  }} viewport={{
    once: true
  }} data-id="element-1164" data-mp="24ez00myy6yfn">
      <div className="flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity" data-id="element-1165" data-mp="29awiaytruev2">
        <div className="w-px h-8 bg-[#D4AF37]/50" data-id="element-1166" data-mp="2o3zoka1wx66h" />
        <div data-id="element-1167" data-mp="2j2k4olbh15po">
          <p className="font-serif text-xl text-[#D4AF37] leading-none mb-1" data-id="element-1168" data-mp="2j44zmc1p6qo2">
            {word}
          </p>
          <p className="text-[10px] text-white/50 uppercase tracking-widest font-light" data-id="element-1169" data-mp="2x34lxd1qmth2">
            {translation}
          </p>
        </div>
      </div>
    </motion.div>;
};